import { Award, Building2, Users, ThumbsUp } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useLanguage } from "@/hooks/useLanguage";

const StatsStrip = () => {
  const { ref, isVisible } = useScrollAnimation(0.15);
  const { t } = useLanguage();

  const stats = [
    { icon: Award, value: "20+", label: t("stats.experience") },
    { icon: Building2, value: "500+", label: t("stats.projects") },
    { icon: Users, value: "20+", label: t("stats.specialists") },
    { icon: ThumbsUp, value: "100%", label: t("stats.satisfaction") },
  ];

  return (
    <section id="par-mums" className="py-16 sm:py-20 bg-surface-blue">
      <div className="container mx-auto px-4" ref={ref}>
        <h2
          className={`text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          {t("stats.title")}
        </h2>
        <p
          className={`text-center text-muted-foreground mb-10 sm:mb-14 max-w-2xl mx-auto text-base sm:text-lg transition-all duration-700 delay-100 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          {t("stats.desc")}
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`bg-card rounded-2xl p-5 sm:p-8 border border-border shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col items-center text-center ${
                isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"
              }`}
              style={{
                transitionDelay: isVisible ? `${200 + i * 120}ms` : "0ms",
                transitionProperty: "all",
                transitionDuration: "600ms",
              }}
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-primary/10 flex items-center justify-center mb-3 sm:mb-4">
                <stat.icon className="w-6 h-6 sm:w-8 sm:h-8 text-primary" />
              </div>
              <span className="text-2xl sm:text-4xl font-extrabold text-primary mb-1">{stat.value}</span>
              <span className="text-xs sm:text-sm text-muted-foreground font-medium">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
